import { LANGUAGE_KEYS } from 'config/languageKeys';

import {
    AUDIO_SUBTITLES_ENGLISH,
    AUDIO_SUBTITLES_HUNGARIAN,
    AUDIO_SUBTITLES_OFF,
} from 'store/player/utils';

import {
    SCREEN_SUBTITLE_OFF,
    SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_EXTRA_LARGE,
    SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_LARGE,
    SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_MEDIUM,
    SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_SMALL,
} from 'screens/Settings/languagesConst';
import {
    AudioSettingItem,
    SubtitlesFontSizeSettingItem,
    SubtitlesSettingItem,
} from 'screens/Settings/types';

const { SETTINGS_HUNGARIAN, SETTINGS_ENGLISH } = LANGUAGE_KEYS;

export const AUDIO_OPTIONS: AudioSettingItem[] = [
    { id: AUDIO_SUBTITLES_HUNGARIAN, title: SETTINGS_HUNGARIAN },
    { id: AUDIO_SUBTITLES_ENGLISH, title: SETTINGS_ENGLISH },
];

export const SUBTITLES_OPTIONS: SubtitlesSettingItem[] = [
    { id: AUDIO_SUBTITLES_OFF, title: SCREEN_SUBTITLE_OFF },
    { id: AUDIO_SUBTITLES_HUNGARIAN, title: SETTINGS_HUNGARIAN },
    { id: AUDIO_SUBTITLES_ENGLISH, title: SETTINGS_ENGLISH },
];

export const DEFAULT_SUBTITLES_FONT_SIZE = '100';
export const SUBTITLES_FONT_SIZE_OPTIONS: SubtitlesFontSizeSettingItem[] = [
    {
        id: '75',
        title: SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_SMALL,
    },
    {
        id: DEFAULT_SUBTITLES_FONT_SIZE,
        title: SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_MEDIUM,
    },
    {
        id: '200',
        title: SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_LARGE,
    },
    {
        id: '300',
        title: SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_EXTRA_LARGE,
    },
];
